// extracted by mini-css-extract-plugin
export default {"titleContainer":"Question_titleContainer__KSTpO","questionTitle":"Question_questionTitle__0zMhY"};